import { render, staticRenderFns } from "./ant-s-t.vue?vue&type=template&id=4fbad46d&scoped=true"
import script from "./ant-s-t.vue?vue&type=script&lang=js"
export * from "./ant-s-t.vue?vue&type=script&lang=js"
import style0 from "./ant-s-t.vue?vue&type=style&index=0&id=4fbad46d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbad46d",
  null
  
)

export default component.exports